<ng-container *transloco="let t">
    <div class="relative" *ngIf="canSearch">
        <!-- Input -->
        <div class="bg-card flex h-10 w-full items-center gap-2 rounded-full border px-3 sm:w-80 md:w-96">
            <mat-icon class="text-hint icon-size-5" [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
            <input
                #searchInput
                type="text"
                data-testid="global-search-input"
                class="min-w-0 flex-auto border-0 bg-transparent text-sm outline-none"
                [formControl]="searchControl"
                [placeholder]="t('general.global_search.placeholder')"
                (focus)="onFocus()"
                (keydown)="onKeydown($event)" />
            <mat-progress-spinner *ngIf="loading" [diameter]="16" [mode]="'indeterminate'"></mat-progress-spinner>
            <button *ngIf="!loading && searchControl.value" type="button" class="flex items-center" (click)="clear()">
                <mat-icon class="text-hint icon-size-4" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <!-- Results: scrolling to the bottom loads the next page -->
        <div
            *ngIf="panelOpen"
            class="bg-card absolute right-0 z-99 mt-2 max-h-100 w-100 overflow-y-auto rounded-lg border shadow-lg sm:w-120"
            (scroll)="onPanelScroll($event)">
            <ng-container *ngIf="results.length > 0">
                <div class="text-secondary bg-card sticky top-0 border-b px-4 py-2 text-xs">
                    {{ t('general.global_search.results_count', { shown: results.length, total: totalCount }) }}
                </div>

                <button
                    *ngFor="let result of results; let i = index; trackBy: trackByResult"
                    type="button"
                    class="flex w-full flex-col items-start gap-1 border-b px-4 py-3 text-left hover:bg-hover last:border-b-0"
                    [ngClass]="{ 'bg-hover': i === activeIndex }"
                    (click)="openResult(result)">
                    <div class="flex w-full items-center gap-2">
                        <span class="font-medium">{{ result.poNumber }}</span>
                        <span
                            *ngIf="result.kind === 'pendingConfirmation'"
                            class="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800">
                            {{ t('general.global_search.pending_approval') }}
                        </span>
                        <span
                            *ngIf="result.kind === 'purchaseOrder' && result.statusName"
                            class="ml-auto rounded-full px-2 py-0.5 text-xs font-medium"
                            [ngStyle]="getStatusBadgeStyle(result.statusId)">
                            {{ result.statusName }}
                        </span>
                    </div>
                    <span *ngIf="result.description" class="text-secondary line-clamp-1 text-sm">{{ result.description }}</span>
                    <span *ngIf="getResultDetails(result) as details" class="text-hint text-xs">{{ details }}</span>
                </button>

                <div *ngIf="loadingMore" class="flex items-center justify-center py-3">
                    <mat-progress-spinner [diameter]="20" [mode]="'indeterminate'"></mat-progress-spinner>
                </div>
            </ng-container>

            <div *ngIf="showNoResults" class="text-secondary px-4 py-3 text-sm">
                {{ t('general.global_search.no_results') }}
            </div>
        </div>
    </div>
</ng-container>
